import { Component, inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-message',
  standalone: false,
  styles: ``,
  templateUrl: './message.component.html',
})
export class MessageComponent implements OnInit {

  title: string | null = null;
  prompt: string = `Are you sure?`;

  private modal = inject(NgbActiveModal);

  ngOnInit(): void {
  }

  dismissModal(): void {
    this.modal.dismiss();
  }


}

